export default __webpack_public_path__ + "static/media/magazine.d7d894c3.png";